
import MmenuLight from 'mmenu-light';
import { navbar } from "../modules/navbar/navbar";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import Scrollbar from 'smooth-scrollbar';
// GSAP
import gsap from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";

window.gsap = gsap;
gsap.registerPlugin(ScrollTrigger);

// import Swiper JS
import Swiper from 'swiper';
import { Controller, Pagination, EffectFade, Autoplay } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/swiper.css';
import 'swiper/modules/effect-fade.css';
import 'swiper/modules/effect-fade-element.css';
import 'swiper/modules/controller.css';
import 'swiper/modules/pagination.css';
import 'swiper/modules/autoplay.css';

// import { getDomIndex, isTouchDevice, mapStyle } from './components/utils';

// Google Maps JS API Loader
import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
const API_KEY = _gmapkey;

class MapManager {
    constructor(containerSelector, itemSelector, options = {}) {
        this.root = document.querySelector(containerSelector);
        if (!this.root) return;
        
        this.items = document.querySelectorAll(itemSelector);
        this.mapElement = this.root.querySelector("#map");
        
        this.config = {
            apiKey: typeof API_KEY !== 'undefined' ? API_KEY : '',
            _root: typeof _root !== 'undefined' ? _root : '', // Percorso base per le immagini
            mapId: "1dc1a8cdebecee4829186ca1",
            // --- OPZIONI DI CENTRAMENTO ---
            initialView: 'fit', // 'fit' (tutti i marker) oppure 'fixed' (usa center/zoom sotto)
            center: { lat: 41.9102, lng: 12.3711 }, // Default: centro Italia
            zoom: 6,
            maxMarkerZoom: 15,
            useScrollbar: false,
            scrollerSelector: '.scroller',
            enableInfoWindow: true,
            cacheExpiration: 30 * 24 * 60 * 60 * 1000,
            ...options
        };

        this.markers = [];
        this.bounds = null;
        this.scrollbar = null;
    }

    // --- UTILS ---
    wait = (ms) => new Promise(res => setTimeout(res, ms));

    createMarkerContent(item, onlyIcon) {
        const content = document.createElement("div");
        content.classList.add("storeInfoWindow");
        
        // Usa _root dalla configurazione
        const iconUrl = `${this.config._root}img/marker.svg`;

        let txt = "";
        if (!onlyIcon) {
            const infoWindowEl = item.querySelector('.infowindow');
            txt = infoWindowEl ? infoWindowEl.innerHTML : "";
        }

        content.innerHTML = `
            <div class="icon" style="background-image: url('${iconUrl}');"></div>
            ${!onlyIcon ? `
                <div class="iw-wrapper">
                    <div class="iw-close"><span></span></div>
                    <div class="iw-content">${txt}</div>
                </div>
            ` : ''}
        `;
        return content;
    }

    showLoader() {
        if (this.root.querySelector('.loader')) return;
        const loader = document.createElement('div');
        loader.className = 'loader';
        loader.innerHTML = '<svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient x1="8.042%" y1="0%" x2="65.682%" y2="23.865%" id="a"><stop stop-color="currentColor" stop-opacity="0" offset="0%"/><stop stop-color="currentColor" stop-opacity=".631" offset="63.146%"/><stop stop-color="currentColor" offset="100%"/></linearGradient></defs><g fill="none" fill-rule="evenodd"><g transform="translate(1 1)"><path d="M36 18c0-9.94-8.06-18-18-18" id="Oval-2" stroke="url(#a)" stroke-width="2"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></path><circle fill="currentColor" cx="36" cy="18" r="1"><animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="0.9s" repeatCount="indefinite"/></circle></g></g></svg>'; 
        this.root.appendChild(loader);
        requestAnimationFrame(() => loader.classList.add('show'));
    }

    hideLoader() {
        const loader = this.root.querySelector('.loader');
        if (loader) {
            loader.classList.remove('show');
            loader.addEventListener('transitionend', () => loader.remove(), { once: true });
            setTimeout(() => loader.remove(), 600);
        }
    }

    // --- LOGICA CORE ---
    async init() {
        if (this.items.length === 0) return;

        try {
            this.showLoader();

            if (this.config.useScrollbar) {
                const scrollEl = this.root.querySelector(this.config.scrollerSelector);
                if (scrollEl) this.scrollbar = Scrollbar.init(scrollEl);
            }

            setOptions({ key: this.config.apiKey, v: 'weekly', libraries: ["places"] });
            const { Map } = await importLibrary("maps");
            const { Geocoder } = await importLibrary("geocoding");
            const { AdvancedMarkerElement } = await importLibrary("marker");
            const { LatLngBounds, LatLng } = await importLibrary("core"); // Carica anche queste

            this.bounds = new LatLngBounds();

            // Inizializziamo la mappa con i valori fissi della config
            this.map = new Map(this.mapElement, {
                center: this.config.center,
                zoom: this.config.zoom,
                mapId: this.config.mapId,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControlOptions: { position: google.maps.ControlPosition.RIGHT_TOP }
            });

            const geocoder = new Geocoder();

            for (const item of this.items) {
                const location = await this.getLocation(item, geocoder);
                if (location) {
                    this.addMarker(item, location, AdvancedMarkerElement, LatLng);
                }
            }

            // --- LOGICA DI CENTRAMENTO INIZIALE ---
            if (this.markers.length > 0) {
                google.maps.event.addListenerOnce(this.map, 'tilesloaded', () => {
                    
                    if (this.config.initialView === 'fit') {
                        // Inquadra tutti i marker
                        this.map.fitBounds(this.bounds);
                        
                        // Evita zoom eccessivi
                        const l = google.maps.event.addListener(this.map, "idle", () => {
                            if (this.map.getZoom() > 16) this.map.setZoom(16);
                            google.maps.event.removeListener(l);
                        });
                    } else {
                        // Se 'fixed', la mappa è già centrata grazie all'init
                        // Possiamo però forzare un refresh in caso di container invisibili
                        google.maps.event.trigger(this.map, "resize");
                    }
                });
            }

        } catch (e) {
            console.error("MapManager Error:", e);
        } finally {
            await this.wait(300);
            this.hideLoader();
        }
    }

    async getLocation(item, geocoder) {
        // 1. Check Coordinate
        const lat = parseFloat(String(item.dataset.lat).replace(',', '.'));
        const lng = parseFloat(String(item.dataset.lng).replace(',', '.'));
        if (!isNaN(lat) && !isNaN(lng)) return { lat, lng };

        // 2. Check Indirizzo + Cache
        const addrEl = item.querySelector('.address');
        if (addrEl) {
            const address = addrEl.innerText;
            const cacheKey = 'geo_cache_' + btoa(address.toLowerCase());
            const cached = localStorage.getItem(cacheKey);
            const now = Date.now();

            if (cached) {
                const data = JSON.parse(cached);
                if (now - data.timestamp < this.config.cacheExpiration) return data.location;
            }

            try {
                const res = await geocoder.geocode({ address });
                if (res.results[0]) {
                    const loc = { lat: res.results[0].geometry.location.lat(), lng: res.results[0].geometry.location.lng() };
                    localStorage.setItem(cacheKey, JSON.stringify({ location: loc, timestamp: now }));
                    await this.wait(250); // Anti-throttle
                    return loc;
                }
            } catch (e) { console.warn("Geocode fallito:", address); }
        }
        return null;
    }

    addMarker(item, location, AdvancedMarkerElement, LatLng) {
        const marker = new AdvancedMarkerElement({
            map: this.map,
            position: location,
            content: this.createMarkerContent(item, !this.config.enableInfoWindow),
            title: item.querySelector('.infowindow--title')?.innerText || ""
        });

        // --- AGGIORNAMENTO LINK GOOGLE MAPS ---
        const url = `https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}`;
        const btn = item.querySelector('.location .btn');
        if (btn) btn.setAttribute('href', url);

        this.markers.push(marker);
        if (this.bounds) this.bounds.extend(new LatLng(location.lat, location.lng));

        this.setupEvents(item, marker, location);
    }

    setupEvents(item, marker, location) {
        const isTouch = 'ontouchstart' in window;
        const markerIcon = marker.content.querySelector('.icon');

        const onSelect = () => {
            if (this.config.enableInfoWindow) {
                this.highlightMarker(marker, item, location);
            }
        };

        marker.addListener("gmp-click", onSelect);

        if (!isTouch) {
            item.addEventListener("click", onSelect);
            
            // Hover effetti
            item.onmouseover = () => {
                markerIcon?.classList.add('bounce');
                item.classList.add("active");
            };
            item.onmouseout = () => { 
                markerIcon?.classList.remove('bounce');
                item.classList.remove("active");
            }

            if (markerIcon) {
                markerIcon.onmouseover = () => {
                    item.classList.add('active');
                    if (this.scrollbar) {
                        this.scrollbar.scrollTo(0, item.offsetTop, 600);
                    } else {
                        const headerH = document.querySelector('.header')?.offsetHeight || 0;
                        window.scrollTo({
                            top: item.getBoundingClientRect().top + window.pageYOffset - headerH,
                            behavior: "smooth"
                        });
                    }
                };
                markerIcon.onmouseout = () => item.classList.remove('active');
            }
        }
    }

    highlightMarker(markerView, store, location) {
        // Cambiamo nome per evitare conflitti con window.close()
        const closeMarker = () => {
            if (this.scrollbar) this.scrollbar.scrollTo(0, 0, 300);
            
            markerView.zIndex = null;
            markerView.content.classList.remove("active");
            store.classList.remove("active");
            
            // Ritorna alla vista globale se previsto
            if (this.config.initialView === 'fit' && this.bounds) {
                setTimeout(() => this.map.fitBounds(this.bounds), 100);
            }
        };

        // Toggle: se clicco su un marker già aperto, lo chiudo
        if (markerView.content.classList.contains("active")) {
            closeMarker();
            return;
        }

        // Reset degli altri marker
        this.markers.forEach((m, i) => {
            m.content.classList.remove("active");
            m.zIndex = null;
            if (this.items[i]) this.items[i].classList.remove("active");
        });

        // Attiva quello attuale
        markerView.content.classList.add("active");
        markerView.zIndex = 1000;
        store.classList.add("active");

        // Inquadramento sul marker
        const mBounds = new google.maps.LatLngBounds();
        mBounds.extend(location);
        this.map.fitBounds(mBounds, { top: 100, bottom: 100, left: 100, right: 100 });

        // Limitazione Zoom
        google.maps.event.addListenerOnce(this.map, "idle", () => {
            if (this.map.getZoom() > this.config.maxMarkerZoom) {
                this.map.setZoom(this.config.maxMarkerZoom);
            }
        });

        // --- GESTIONE TASTO CHIUSURA (iw-close) ---
        // Cerchiamo il tasto di chiusura dentro il contenuto del marker appena attivato
        const closeMarkerBtn = markerView.content.querySelector('.iw-close');
        if (closeMarkerBtn) {
            // Rimuoviamo eventuali listener precedenti e aggiungiamo quello nuovo
            closeMarkerBtn.onclick = (e) => {
                e.preventDefault();
                e.stopPropagation();
                closeMarker();
            };
        }
    }
}

// Form Validation JS
import Pristine from 'pristinejs';

const defaultPristineConfig = {
    classTo: 'form-group',
    errorClass: 'has-danger',
    successClass: 'has-success',
    errorTextParent: 'form-group',
    errorTextTag: 'div',
    errorTextClass: 'text-help' 
};

const imagesLoaded = require('imagesloaded');

import Packery from 'packery';

import lightGallery from 'lightgallery';

// import A11yDialog from 'a11y-dialog';
import { formReset } from './components/form';

const slideDown = element => element.style.height = 'auto';
const slideUp = element => element.style.height = 0;

var getNextSibling = function (elem, selector) {
	// Get the next sibling element
	var sibling = elem.nextElementSibling;
	// If there's no selector, return the first sibling
	if (!selector) return sibling;
	// If the sibling matches our selector, use it
	// If not, jump to the next sibling and continue the loop
	while (sibling) {
		if (sibling.matches(selector)) return sibling;
		sibling = sibling.nextElementSibling
	}

};

const formResponseDialog = (title, message) => {
    let alertDialog = document.querySelector('#alert-dialog');
    let alertDialogA11 = new A11yDialog(alertDialog);
    let alertDialogTitle = alertDialog.querySelector('.dialog-title .title');
    let alertDialogContainer = alertDialog.querySelector('.dialog-wrap');
    alertDialogTitle.innerHTML = title;
    
    let dialogContent = `
        <div class="dialog-text">
            <p>
                ${message}
            </p>
        </div>
    `;
        
    alertDialogContainer.innerHTML = dialogContent;    
    alertDialogA11.show();
}

/* CONTENT 
LOADED */
document.addEventListener("DOMContentLoaded", () => {
    const menuElement = document.querySelector(".main-nav");
    const menu = new MmenuLight(menuElement);
    const body = document.querySelector("body");
    const navigator = menu.navigation({
        title: menuElement.dataset.title || "Menu",
    });

    document.querySelectorAll(".main-menu ul").forEach((list) => {
        if(list.classList.contains("active")) {
            navigator.openPanel(
                list
            );
        }
    })
    
    document.querySelector(".js-navbar-toggler")
        .addEventListener( "click", ( evnt ) => {
            evnt.preventDefault();
            body.classList.add("drawer-is-open");
            disableBodyScroll(document.querySelector('.main-menu'), {
                reserveScrollBarGap: true,
            });
        });

    document.querySelector(".drawer--close")
        .addEventListener( "click", ( evnt ) => {
            evnt.preventDefault();
            body.classList.remove("drawer-is-open");
            enableBodyScroll(document.querySelector('.main-menu'));
        });

    // Search modal
    document.querySelector(".js-search-toggler")
        .addEventListener( "click", ( evnt ) => {
            evnt.preventDefault();
            document.querySelector('.search-modal').classList.add("active");
            disableBodyScroll(document);
        });

    document.querySelector(".js-search-toggler--close")
        .addEventListener( "click", ( evnt ) => {
            evnt.preventDefault();
            document.querySelector('.search-modal').classList.remove("active");
            enableBodyScroll(document);
        });

    navbar(document);

    // HERO CAROUSEL
    let heroHighlightsImageSlider = document.querySelector('.hero--highlights--imageSlider .swiper');
    let heroHighlightsTextSlider = document.querySelector('.hero--highlights--textSlider .swiper');

    if(heroHighlightsImageSlider){
        const heroHighlightsImageSwiper = new Swiper(heroHighlightsImageSlider, {
            modules: [ EffectFade, Autoplay, Pagination, Controller ],
            autoplay: {
                delay: 5000,
                pauseOnMouseEnter: true
            },
            lazy: true,
            effect: "fade",
            fadeEffect: {
                crossFade: false
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });

        const heroHighlightsTextSwiper = new Swiper(heroHighlightsTextSlider, {
            modules: [ EffectFade, Autoplay, Controller ],
            effect: "fade",
            fadeEffect: {
                crossFade: true
            }
        });

        heroHighlightsTextSlider.onmouseover = (event) => {
            heroHighlightsImageSwiper.autoplay.pause();
        }
        heroHighlightsTextSlider.onmouseout = (event) => {
            heroHighlightsImageSwiper.autoplay.resume();
        }

        heroHighlightsImageSwiper.controller.control = heroHighlightsTextSwiper;
        heroHighlightsTextSwiper.controller.control = heroHighlightsImageSwiper;
    }

    // Accordion
    if(document.querySelector(".accordion--list")){
        let accordionList = document.querySelectorAll(".accordion--list");

        accordionList.forEach((list) => {
            let accordions = list.querySelectorAll(".accordion--item");
            
            accordions.forEach((accordion) => {
                let intro = accordion.querySelector(".accordion--title");
    
                let openAccordion = (accordion) => {
                    let content = accordion.querySelector(".accordion--content");
                    accordion.classList.add("active");

                    if(intro.querySelector('.thom-form__radio--original')){
                        intro.querySelector('.thom-form__radio--original').checked = true;
                    }
                    if(content){
                        slideDown(content);
                    }
                };
        
                let closeAccordion = (accordion) => {
                    let content = accordion.querySelector(".accordion--content");
                    accordion.classList.remove("active");

                    if(intro.querySelector('.thom-form__radio--original')){
                        accordions.forEach((accordion) => accordion.querySelector('.thom-form__radio--original').checked = false)
                        
                    }
                    if(content){
                        slideUp(content);
                    }
                };
    
                intro.onclick = () => {
                    if (accordion.classList.contains('active')) {
                        closeAccordion(accordion);
                    } else {
                        if(!list.classList.contains('multy')){
                            accordions.forEach((accordion) => closeAccordion(accordion));
                        }
                        openAccordion(accordion);
                    }
                };

                if(accordion.classList.contains('active')){
                    openAccordion(accordion);
                }
            });  
        });        
    }

    // Timeline
    const timeline = document.querySelector('.timeline');
    if(timeline){
        // let timelineLine = timeline.querySelector('.timeline__line');
        let timelineList = timeline.querySelector('.timeline-list');

        let timelineBlocks = timelineList.querySelectorAll('.timeline-item');

        timelineList.style.setProperty('opacity', '0');

        imagesLoaded( timelineList, function( instance ) {
            // console.log(instance.images.length + ' images loaded');
            // images have loaded
            [...timelineBlocks].forEach((el, index) => {
                if(index != 0){
                    // Animate progress bar on each element and Add active class on all element except first one
                    gsap.to(el.querySelector('.progress'), {
                        height: '100%',
                        ease: "none",
                        scrollTrigger: {
                            trigger: el.querySelector('.timeline-item__line'),
                            start: "top center",
                            end: "bottom center",
                            scrub: 1,
                            // markers: true,
                            onLeave: () => {
                                el.classList.add('is-active');
                            },
                            onEnterBack: () => {
                                el.classList.remove('is-active');
                            }
                        }
                    });
                } else {
                    // Add active class on first element
                    gsap.to(el, {
                        ease: "none",
                        scrollTrigger: {
                            trigger: el,
                            start: "top center",
                            end: "bottom center",
                            scrub: 1,
                            // markers: true,
                            onEnter: () => {
                                el.classList.add('is-active');
                            },
                            onLeaveBack: () => {
                                el.classList.remove('is-active');
                            }
                        }
                    });
                }
            })
            timelineList.style.setProperty('opacity', '1');
        });
    }

    // Form
    let thomforms = document.querySelectorAll('.thom-form');
    if(document.querySelector(".grecaptcha-badge")){
        document.querySelector('.thom-form form') ? document.querySelector(".grecaptcha-badge").classList.remove('hide') : document.querySelector(".grecaptcha-badge").classList.add('hide');
    }
    if(thomforms){
        thomforms.forEach((formWrap) => {
            let form = formWrap.querySelector("form")
            if(form){
                let validateForm = new Pristine(form, defaultPristineConfig);
                let files = form.querySelectorAll('[type="file"]');

                if(files){
                    files.forEach(file => {
                        
                        file.addEventListener('change', function(){
                            var filename = this.value.replace('C:\\fakepath\\', '');
                            var name = getNextSibling(this, '.thom-form__file--name');
                            name.innerText = filename;
                        })
                        validateForm.addValidator(file, function(value) {
                            if(!this.files[0]){
                                return true;
                            }
                            return !(this.files[0].size > this.maxLength);
                        }, file.dataset.pristineMaxlengthMessage, 2, false);
                    });
                }

                form.addEventListener('submit', function (e) {
                    e.preventDefault();
                    formWrap.classList.add('loading');

                    let valid = validateForm.validate(); // returns true or false

                    if(form.querySelector(".GoogleCaptchaToken")){
                        var rSiteKey = form.querySelector('button[type=submit]').dataset.sitekey;
                        var rAction = form.querySelector('button[type=submit]').dataset.action;
                        grecaptcha.ready(function() {
                            grecaptcha.execute(rSiteKey, {action: rAction}).then(function(token) {
                                // Add your logic to submit to your backend server here.
                                // Response Form
                                // console.log(token)
                                form.querySelector(".GoogleCaptchaToken").value = token;
                                FormSubmit(valid);
                            });
                        });
                    } else {
                        FormSubmit(valid);
                    }
                })
                
                let FormSubmit = (valid) => {
                    if(valid){
                        // console.log('Form valid');
                        let formData = new FormData(form);
                        fetch(form.getAttribute('action'), {
                            method: form.getAttribute('method'),
                            body: formData
                        }).then(response => {
                            // console.log('Response =' + response);
                            // The API call was successful!
                            if (response.ok) {
                                return response.json();
                            } else {
                                return Promise.reject(response);
                            }
                        }).then(function (data) {
                            // console.log('Data =' + data);
                            if(data.Status){
                                // console.log('Form submitted successfully');
                                if(data.Url !== undefined && data.Url !== null && data.Url !== ""){
                                    // console.log('Redirecting to: ' + data.Url);
                                    window.location.href = data.Url
                                } else {
                                    // console.log('No redirect URL provided');
                                    if(data.Message){
                                        console.log('Showing response dialog: ' + data.Message);
                                        formResponseDialog(data.Title, data.Message);
                                    }
                                }
                                formReset(formWrap, form);
                            } else {
                                console.log('Form submission failed');
                                if(data.Message){
                                    formResponseDialog(data.Title, data.Message);
                                }
                                formWrap.classList.remove('loading');
                            }
            
                            return true;
                        }).catch(function (err) {
                            console.warn('Form submission error:', err);
                            // There was an error
                            // console.warn('Something went wrong.', err);
                            if(formWrap.querySelector('.thom-form--response')){
                                formWrap.que,rySelector('.thom-form--response').classList.remove('is-hidden');
                            }
                            if(formWrap.classList.contains('loading')){
                                formWrap.classList.remove('loading');
                            }
                        });
                    } else {
                        console.log('Form not valid');
                        // console.log(formWrap);
                        // console.log(formWrap.querySelector('.thom-form--response'));
                        if(formWrap.querySelector('.thom-form--response')){
                            formWrap.querySelector('.thom-form--response').classList.remove('is-hidden');
                        }
                        if(formWrap.classList.contains('loading')){
                            formWrap.classList.remove('loading');
                        }
                    }
                }
            }
        })
    }

    // Certificazioni
    var certificarionGrid = document.querySelector('.certifications--list');
    if(certificarionGrid){
        var pckryCertificarion = new Packery(certificarionGrid, {
            // options...
            itemSelector: '.certifications--item',
            percentPosition: true,
            gutter: 0,
            horizontalOrder: true,
            layout: false
        });

        imagesLoaded(certificarionGrid).on( 'progress', function() {
            pckryCertificarion.layout();
        });
    }

    // Projects
    var projectsGrid = document.querySelector('.projects--list');
    if(projectsGrid){
        var pckryProjects = new Packery(projectsGrid, {
            // options...
            itemSelector: '.projects--item',
            percentPosition: true,
            layout: false
        });

        imagesLoaded(projectsGrid).on( 'progress', function() {
            pckryProjects.layout();
        });

        // Filtro
        const projectsFilter = document.querySelector('.projects--filters--item select');
        const projectsItems = projectsGrid.querySelectorAll('.projects--item');

        // Aggiungi un event listener alla select
        projectsFilter.addEventListener('change', function() {
            let valoreFiltrato = this.value;
            projectsItems.forEach(li => {
                if(li.getAttribute('data-status') === valoreFiltrato || valoreFiltrato === "all" || valoreFiltrato === "*" || valoreFiltrato === "tutti"){
                    li.style.display = 'block';                  
                } else {
                    li.style.display = 'none';
                }
                pckryProjects.layout();                
            });
        });
    }

    // Gallery
    var galleryGrids = document.querySelectorAll('.gallery--list');
    if(galleryGrids){
        galleryGrids.forEach((galleryGrid) => {
            var pckryGallery = new Packery(galleryGrid, {
                // options...
                itemSelector: '.gallery--item',
                percentPosition: true,
                gutter: 0,
                horizontalOrder: true,
                layout: false
            });

            imagesLoaded(galleryGrid).on( 'progress', function() {
                pckryGallery.layout();
            });

            lightGallery(galleryGrid, {
                licenseKey: 'EB342F23-EEA8-48C2-B726-0CFCE5A4AECF',
                mode: 'lg-fade',
                counter: false,
                download: false
            });
        });
    }

    // Doc filters
    let filterBtn = document.getElementById('doc-filters--toggler');
    let filterCol = document.getElementById('doc-filters');

    const handleFiltersResize = () => {
        let width = window.innerWidth;

        // Gestione Filtri sotto i 920px
        if (width <= 920) {
            filterBtn.classList.remove('selected');
            // Nota: il CSS gestisce già il display: none tramite media query
        } else {
            // Se torniamo sopra i 920px, il bottone riflette lo stato reale della colonna
            if (!filterCol.classList.contains('is-hidden')) {
                filterBtn.classList.add('selected');
            }
        }
    };
    
    let toggleFilters = () => {
        let isHidden = filterCol.classList.toggle('active');
        if (window.innerWidth > 920){
            isHidden = filterCol.classList.toggle('is-hidden');
        } else {
            document.querySelector('.header').classList.add("hidden");
            disableBodyScroll(document.querySelector('.nav--filters'), {
                reserveScrollBarGap: true,
            });

            filterCol.querySelector(".doc-filters--close").addEventListener( "click", ( evnt ) => {
                evnt.preventDefault();
                filterCol.classList.remove("active");
                document.querySelector('.header').classList.remove("hidden");
                enableBodyScroll(document.querySelector('.nav--filters'));

                if(document.getElementById('documentationFiltersBtnToggler')){
                    document.getElementById('documentationFiltersBtnToggler').scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                }
            });
        }
        
        filterBtn.classList.toggle('selected', !isHidden);
    };
    
    if(filterBtn && filterCol){
        filterBtn.addEventListener('click', toggleFilters);
        window.addEventListener('resize', handleFiltersResize);

        handleFiltersResize();
    }

    // Doc map
    let mapBtn = document.getElementById('doc-map--toggler');
    let mapCol = document.getElementById('doc-map');
    /**
    * Sincronizza lo stato dei componenti al resize della finestra
    */
    const handleMapResize = () => {
        let width = window.innerWidth;

        // Gestione Mappa sotto i 1200px
        if (width <= 1200) {
            mapBtn.classList.remove('selected');
            // Nota: il CSS gestisce già il display: none tramite media query
        } else {
            // Se torniamo sopra i 1200px, il bottone riflette lo stato reale della colonna
            if (!mapCol.classList.contains('is-hidden')) {
                mapBtn.classList.add('selected');
            }
        }

        if(mapCol.querySelector('.gm-style')){
            return;
        } else {
            // initMapCompanyDocumentation();
            const mapDocumentationSearch = new MapManager('#doc-map', '.documentation--list-companies--item', {
                initialView: 'fixed', // Ignora i bounds, usa center e zoom definiti
                center: { lat: 41.9102083, lng: 12.3708484 }, // Roma
                zoom: 5.5,
                enableInfoWindow: false
            });
            mapDocumentationSearch.init();
        }
    };
    /**
    * Gestisce il toggle della mappa   
    */
    let toggleMap = () => {
        // Sotto i 1200px la mappa è disabilitata via CSS, 
        // evitiamo che il bottone faccia qualcosa
        if (window.innerWidth <= 1200) return;

        const isHidden = mapCol.classList.toggle('is-hidden');
        mapBtn.classList.toggle('selected', !isHidden);

        // Forza il ricalcolo della mappa (essenziale per Google Maps/Leaflet)
        window.dispatchEvent(new Event('resize'));
    };
    
    if(mapBtn && mapCol){
        mapBtn.addEventListener('click', toggleMap);
        window.addEventListener('resize', handleMapResize);

        if (window.innerWidth > 1200 && !mapCol.classList.contains('is-hidden')) {
            mapBtn.classList.add('selected');
        }
        handleMapResize(); // Chiamata iniziale per sincronizzare lo stato al caricamento della pagina
    }

    

    // Stores Search
    if(document.querySelector("#storesSearch")){
        const mapStorelocator = new MapManager('#storesSearch', '.store', {
            initialView: 'fit', // Si adatta ai marker (es. tutti i negozi in Lombardia)
            useScrollbar: true,
            maxMarkerZoom: 6
        });
        mapStorelocator.init();
    }

    // Media Materiali
    var mediaMaterialsGrid = document.querySelector('.media-materials--list');
    if(mediaMaterialsGrid){
        var pckryMediaMaterials = new Packery(mediaMaterialsGrid, {
            // options...
            itemSelector: '.media-materials--list--item',
            percentPosition: true,
            layout: false
        });

        imagesLoaded(mediaMaterialsGrid).on( 'progress', function() {
            pckryMediaMaterials.layout();
        });

        // Filtro
        const mediaMaterialsFilter = document.querySelectorAll('.media--filters--item');
        const mediaMaterialsItems = mediaMaterialsGrid.querySelectorAll('.media-materials--list--item');
        const filterArray = [];

        const filterMediaMaterials = () => {

            mediaMaterialsItems.forEach(item => {
                let brandArray = item.getAttribute('data-brand').split(" ");
                if(
                    (filterArray['Anno'] === item.getAttribute('data-year') || filterArray['Anno'] === "all" || filterArray['Anno'] === "*" || filterArray['Anno'] === "tutti") &&
                    (filterArray['Marchio'] === item.getAttribute('data-brand') || filterArray['Marchio'] === "all" || filterArray['Marchio'] === "*" || filterArray['Marchio'] === "tutti" || brandArray.includes(filterArray['Marchio']))
                ){
                    item.style.display = 'block';                  
                } else {
                    item.style.display = 'none';
                }
                pckryMediaMaterials.layout();                
            });

        }

        // Aggiungi un event listener alla select
        [...mediaMaterialsFilter].forEach(el => {

            let nameFilter = el.querySelector('select').getAttribute('name');
            let valoreFiltrato = el.querySelector('select').value;
            filterArray[nameFilter] = valoreFiltrato;

            filterMediaMaterials();            
            
            el.querySelector('select').addEventListener('change', function() {
                let nameFilter = this.getAttribute('name');
                let valoreFiltrato = this.value;
                filterArray[nameFilter] = valoreFiltrato;
                
                filterMediaMaterials();
            });
        });
    }

    // Media Press
    var mediaPressList = document.querySelector('.media-press-releases--list');
    if(mediaPressList){
        
        // Filtro
        const mediaPressFilter = document.querySelectorAll('.media--filters--item');
        const mediaPressItems = mediaPressList.querySelectorAll('.media-press-releases--item');
        const filterArray = [];

        const filterMediaPress = () => {

            mediaPressItems.forEach(item => {
                if(
                    (filterArray['Anno'] === item.getAttribute('data-year') || filterArray['Anno'] === "all" || filterArray['Anno'] === "*" || filterArray['Anno'] === "tutti") 
                ){
                    item.style.display = 'block';                  
                } else {
                    item.style.display = 'none';
                }       
            });

        }

        // Aggiungi un event listener alla select
        [...mediaPressFilter].forEach(el => {

            let nameFilter = el.querySelector('select').getAttribute('name');
            let valoreFiltrato = el.querySelector('select').value;
            filterArray[nameFilter] = valoreFiltrato;

            filterMediaPress();            
            
            el.querySelector('select').addEventListener('change', function() {
                let nameFilter = this.getAttribute('name');
                let valoreFiltrato = this.value;
                filterArray[nameFilter] = valoreFiltrato;
                
                filterMediaPress();
            });
        });
    }

    // PARTNERS CAROUSEL
    let partnersCarouselsItems = document.querySelectorAll('.partners-carousel');

    if(partnersCarouselsItems){
        partnersCarouselsItems.forEach((carousel) => {
            let partnersCarousel = carousel.querySelector('.swiper');
            let totalSlides = partnersCarousel.querySelectorAll('.swiper-slide').length;

            let swiperInstance = null;
            let lastLoopState = null; // Tiene traccia dello stato precedente (true/false) per evitare loop infiniti di init

            // Funzione per determinare quante slide servono nel breakpoint attuale
            function getSlidesPerView() {
                let width = window.innerWidth;
                if (width >= 1500) return 7;
                if (width >= 1300) return 6;
                if (width >= 960)  return 5;
                if (width >= 640)  return 4;
                return 3; // Mobile di base
            }

            function initOrUpdateSwiper() {
                let currentSlidesPerView = getSlidesPerView();
                
                // Il loop si attiva se le slide totali sono MAGGIORI del slidesPerView attuale
                let shouldLoop = totalSlides > currentSlidesPerView;

                // Se lo stato del loop non è cambiato, non facciamo nulla (ottimizzazione performance)
                if (swiperInstance && shouldLoop === lastLoopState) {
                    return;
                }

                // Se lo stato è cambiato e Swiper esiste già, lo distruggiamo prima di ricrearlo
                if (swiperInstance) {
                    swiperInstance.destroy(true, true);
                }

                lastLoopState = shouldLoop;

                swiperInstance = new Swiper(partnersCarousel, {
                    modules: [ Autoplay, Pagination, Controller ], // Rimasto rimosso EffectFade
                    slidesPerView: 3,
                    spaceBetween: -1,
                    freeMode: true,
                    
                    // Configurazione dinamica in tempo reale
                    loop: shouldLoop,
                    watchOverflow: true,
                    
                    autoplay: shouldLoop ? {
                        delay: 3000,
                        pauseOnMouseEnter: true
                    } : false,
                    
                    lazy: true,
                    breakpoints: {
                        640: {
                            slidesPerView: 4,
                            pagination: {
                                el: carousel.querySelector(".partners-carousel--pagination"),
                                clickable: true,
                                dynamicBullets: true,
                                dynamicMainBullets: 3
                            },
                        },
                        960: {
                            slidesPerView: 5,
                            pagination: {
                                el: carousel.querySelector(".partners-carousel--pagination"),
                                clickable: true,
                                dynamicBullets: true,
                                dynamicMainBullets: 3
                            },
                        },
                        1300: {
                            slidesPerView: 6,
                            pagination: {
                                el: carousel.querySelector(".partners-carousel--pagination"),
                                clickable: true,
                                dynamicBullets: true,
                                dynamicMainBullets: 3
                            },
                        },
                        1500: {
                            slidesPerView: 7,
                            pagination: {
                                el: carousel.querySelector(".partners-carousel--pagination"),
                                clickable: true,
                                dynamicBullets: true,
                                dynamicMainBullets: 3
                            },
                        }
                    }
                });
            }

            // Inizializzazione al caricamento della pagina
            initOrUpdateSwiper();

            // Aggiorna lo stato al ridimensionamento della finestra (con un minimo di controllo)
            window.addEventListener('resize', initOrUpdateSwiper);
        })
    }

});
